import React, {Component} from "react";
import {
    Alert,
    AppBar,
    Box, Button, Chip,
    Dialog, DialogActions, DialogContent,
    DialogTitle, Grid, Grow,
    IconButton,
    Menu,
    MenuItem, Snackbar, TextField,
    Toolbar,
    Tooltip,
    Typography
} from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import User from "../backend/User";
import {Navigate} from "react-router-dom";
import Backend from "../backend/Backend";
import Config from "../utils/Config";

class HeaderComponent extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            username: User.getDisplayName(),
            anchorEl: null,
            logout: false,
            openChangePasswordDialog: false,
            oldPassword: "",
            newPassword: "",
            newRepeatingPassword: "",
            oldPasswordFalse: false,
            newPasswordsNotEqual: false,
            changePasswordSnackbarOpen: false,
            changePasswordSnackbarSeverity: "error",
            changePasswordSnackbarText: "",
            openInfoDialog: false,
            isEntraIdUser: User.getAuthProvider() === 'entraid',
            alreadyMerged: User.isMerged(),
            openMergeDialog: false,
            mergeUsername: "",
            mergePassword: "",
            mergeError: null
        }
    }

    handleMenu = (event) => {
        this.setState({anchorEl: event.currentTarget});
    }

    handleClose = () => {
        this.setState({anchorEl: null});
    }

    handleLogout = () => {
        this.setState({logout: true}, () => {
            User.removeToken();
            localStorage.removeItem('jwt_admin');
        });
    }

    handleStopImpersonation = () => {
        User.stopImpersonation();
        window.location = process.env.PUBLIC_URL + '/admin/users';
    }

    handleSwitchAccount = () => {
        window.location = process.env.PUBLIC_URL + '/select-account';
    }

    handleOldPasswordChange = (event) => {
        this.setState({oldPassword: event.target.value});
    }

    handleNewPasswordChange = (event) => {
        this.setState({newPassword: event.target.value});
    }

    handleNewRepeatingPasswordChange = (event) => {
        this.setState({newRepeatingPassword: event.target.value});
    }

    handleCloseChangePasswordDialog = () => {
        this.setState({openChangePasswordDialog: false})
    }

    closeSnackbar = () => {
        this.setState({changePasswordSnackbarOpen: false})
    }

    saveNewPassword = () => {
        if(this.state.newPassword !== this.state.newRepeatingPassword) {
            this.setState({newPasswordsNotEqual: true})
        } else {
            this.setState({newPasswordsNotEqual: false})
            let body = {
                oldPassword: this.state.oldPassword,
                newPassword: this.state.newPassword
            };
            Backend.postData('/api/actions/changepassword', body)
                .then(res => {
                    this.setState({changePasswordSnackbarSeverity: "success"})
                    this.setState({changePasswordSnackbarText: 'Passwort wurde geändert!'})
                    this.setState({changePasswordSnackbarOpen: true})
                    this.handleCloseChangePasswordDialog();
                }, error => {
                    if (error.response.status === 403) {
                        this.setState({oldPasswordFalse: true})
                    } else {
                        this.setState({changePasswordSnackbarSeverity: "error"})
                        this.setState({changePasswordSnackbarText: 'Fehler beim Ändern des Passworts!'})
                        this.setState({changePasswordSnackbarOpen: true})
                        this.handleCloseChangePasswordDialog();
                    }
                })
        }
    }


    handleMergeSubmit = () => {
        Backend.postData('/api/actions/mergelocalaccount', {
            username: this.state.mergeUsername,
            password: this.state.mergePassword
        }).then(() => {
            User.removeToken();
            window.location.href = Config.baseURL + '/api/v2/auth/entraid/login';
        }, error => {
            if (error.response && error.response.status === 403) {
                this.setState({mergeError: 'wrongPassword'});
            } else if (error.response && (error.response.status === 401 || error.response.status === 404)) {
                this.setState({mergeError: 'notFound'});
            } else {
                this.setState({mergeError: 'generic'});
            }
        });
    }

    render() {
        if(this.state.logout) {
            return <Navigate to={"/login"} replace/>
        }

        const impersonatedBy = User.getImpersonatedBy();
        // Kontoverbund ist der regulaere Arbeitsmodus des Benutzers, kein
        // Admin-Eingriff — daher ruhigere Farbe und anderer Ausstieg.
        const viaRelation = User.isRelationImpersonation();

        return (
            <Box sx={{flexGrow: 1}}>
                {impersonatedBy && (
                    <Box sx={{
                        backgroundColor: viaRelation ? '#00695c' : '#e65100',
                        color: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 2,
                        px: 2,
                        py: 0.75,
                        fontSize: '0.875rem'
                    }}>
                        <Typography variant="body2" sx={{fontWeight: 'bold'}}>
                            {viaRelation
                                ? `Angemeldet als: ${this.state.username}`
                                : `Impersonierung aktiv — angemeldet als: ${this.state.username}`}
                        </Typography>
                        <Chip
                            label={viaRelation
                                ? `Zugang über: ${impersonatedBy.username}`
                                : `Admin: ${impersonatedBy.username}`}
                            size="small"
                            sx={{backgroundColor: 'rgba(255,255,255,0.2)', color: '#fff', fontSize: '0.75rem'}}
                        />
                        <Button
                            size="small"
                            variant="outlined"
                            startIcon={viaRelation ? <SwapHorizIcon/> : <ExitToAppIcon/>}
                            onClick={viaRelation ? this.handleSwitchAccount : this.handleStopImpersonation}
                            sx={{color: '#fff', borderColor: 'rgba(255,255,255,0.7)', '&:hover': {borderColor: '#fff', backgroundColor: 'rgba(255,255,255,0.1)'}}}
                        >
                            {viaRelation ? 'Konto wechseln' : 'Impersonierung beenden'}
                        </Button>
                    </Box>
                )}
                <AppBar position={"static"} color={"primary"}>
                    <Toolbar>
                        <Box display={'flex'} flexGrow={1}>
                            <Typography
                                variant={"h6"}
                                noWrap
                                component={"div"}
                                sx={{display: {xs: 'none', sm: 'block'}}}>
                                WebTrain
                            </Typography>
                        </Box>
                        <Typography
                            style={{fontSize: '1rem'}}
                            variant={"h6"}
                            noWrap
                            component={"div"}
                            sx={{display: {xs: 'none', sm: 'block'}}}>
                            {this.state.username}
                        </Typography>
                        <Tooltip title={"Settings"}>
                            <IconButton
                                onClick={this.handleMenu}
                                size={"large"}
                                color={"inherit"}
                                aria-controls="menu-appbar">
                                <SettingsIcon/>
                            </IconButton>
                        </Tooltip>
                        <Menu open={Boolean(this.state.anchorEl)}
                              id="menu-appbar"
                              onClose={this.handleClose}
                              anchorEl={this.state.anchorEl}
                              anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                              keepMounted
                              transformOrigin={{vertical: 'bottom', horizontal: 'right'}}>
                            {!this.state.isEntraIdUser && <MenuItem onClick={() => {
                                this.setState({openChangePasswordDialog: true, oldPasswordFalse: false, newPasswordsNotEqual: false});
                            }}>
                                <Typography textAlign={"center"}>
                                    Passwort ändern
                                </Typography>
                            </MenuItem>}
                            {this.state.isEntraIdUser && !this.state.alreadyMerged && <MenuItem onClick={() => {
                                this.setState({openMergeDialog: true, mergeUsername: "", mergePassword: "", mergeError: null});
                            }}>
                                <Typography textAlign={"center"}>
                                    Lokales Konto verknüpfen
                                </Typography>
                            </MenuItem>}
                            <MenuItem onClick={() => {
                                this.setState({openInfoDialog: true});
                            }}>
                                <Typography textAlign={"center"}>
                                    Info
                                </Typography>
                            </MenuItem>
                        </Menu>
                        {User.isAdmin() && (
                            <>
                                <Tooltip title={"Administration"} disableInteractive>
                                    <IconButton
                                        onClick={() => { window.location = process.env.PUBLIC_URL + "/admin/users"; }}
                                        size={"large"}
                                        color={"inherit"}>
                                        <AdminPanelSettingsIcon/>
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={"Rolle/Tenant wechseln"} disableInteractive>
                                    <IconButton
                                        onClick={() => { window.location = process.env.PUBLIC_URL + "/admin-select"; }}
                                        size={"large"}
                                        color={"inherit"}>
                                        <SwapHorizIcon/>
                                    </IconButton>
                                </Tooltip>
                            </>
                        )}
                        <Tooltip title={"Logout"} disableInteractive>
                            <IconButton
                                onClick={this.handleLogout}
                                size={"large"}
                                color={"inherit"}>
                                <LogoutIcon/>
                            </IconButton>
                        </Tooltip>
                    </Toolbar>
                </AppBar>

                <Dialog open={this.state.openChangePasswordDialog} onClose={this.handleCloseChangePasswordDialog}>
                    <DialogTitle sx={{backgroundColor: 'rgb(0,150,136)'}} color={"white"}>
                        Passwort ändern
                    </DialogTitle>
                    <DialogContent>
                        <TextField
                        autoFocus
                        margin={"dense"}
                        label={"Altes Passwort"}
                        type={"password"}
                        fullWidth
                        variant={"standard"}
                        onChange={this.handleOldPasswordChange}
                        error={this.state.oldPasswordFalse}
                        helperText={this.state.oldPasswordFalse ? 'Passwort nicht korrekt' : ''}/>

                        <TextField
                            autoFocus
                            margin={"dense"}
                            label={"Neues Passwort"}
                            type={"password"}
                            fullWidth
                            variant={"standard"}
                            onChange={this.handleNewPasswordChange}
                            error={this.state.newPasswordsNotEqual}
                            helperText={this.state.newPasswordsNotEqual ? 'Passwörter stimmen nicht überein' : ''}/>

                        <TextField
                            autoFocus
                            margin={"dense"}
                            label={"Neues Passwort wiederholen"}
                            type={"password"}
                            fullWidth
                            variant={"standard"}
                            onChange={this.handleNewRepeatingPasswordChange}
                            error={this.state.newPasswordsNotEqual}
                            helperText={this.state.newPasswordsNotEqual ? 'Passwörter stimmen nicht überein' : ''}/>
                    </DialogContent>
                    <DialogActions>
                        <Button style={{color: "gray"}} onClick={this.handleCloseChangePasswordDialog}>Abbrechen</Button>
                        <Button disabled={this.state.oldPassword.length === 0 || this.state.newPassword.length === 0 || this.state.newRepeatingPassword.length === 0} color={"primary"} onClick={this.saveNewPassword}>Speichern</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={this.state.openInfoDialog} onClose={() => {
                    this.setState({openInfoDialog: false})
                }}>
                    <DialogTitle sx={{backgroundColor: 'rgb(0,150,136)'}} color={"white"}>
                        Info
                    </DialogTitle>
                    <DialogContent>
                        <Box marginTop={2}>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    Version:
                                </Grid>
                                <Grid item xs={6}>
                                    {Config.version}
                                </Grid>
                                {/*<Grid item xs={3}>*/}
                                {/*    Kontakt:*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={9}>*/}
                                {/*    hans.dischinger@siemens.com*/}
                                {/*</Grid>*/}
                            </Grid>
                        </Box>
                    </DialogContent>
                </Dialog>

                <Dialog open={this.state.openMergeDialog} onClose={() => this.setState({openMergeDialog: false})}>
                    <DialogTitle sx={{backgroundColor: 'rgb(0,150,136)'}} color={"white"}>
                        Lokales Konto verknüpfen
                    </DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin={"dense"}
                            label={"Benutzername"}
                            type={"text"}
                            fullWidth
                            variant={"standard"}
                            value={this.state.mergeUsername}
                            onChange={(e) => this.setState({mergeUsername: e.target.value})}
                            error={this.state.mergeError === 'notFound'}
                            helperText={this.state.mergeError === 'notFound' ? 'Benutzer nicht gefunden' : ''}/>
                        <TextField
                            margin={"dense"}
                            label={"Passwort"}
                            type={"password"}
                            fullWidth
                            variant={"standard"}
                            value={this.state.mergePassword}
                            onChange={(e) => this.setState({mergePassword: e.target.value})}
                            error={this.state.mergeError === 'wrongPassword'}
                            helperText={this.state.mergeError === 'wrongPassword' ? 'Passwort nicht korrekt' : this.state.mergeError === 'generic' ? 'Ein Fehler ist aufgetreten' : ''}/>
                    </DialogContent>
                    <DialogActions>
                        <Button style={{color: "gray"}} onClick={() => this.setState({openMergeDialog: false})}>Abbrechen</Button>
                        <Button
                            disabled={this.state.mergeUsername.length === 0 || this.state.mergePassword.length === 0}
                            color={"primary"}
                            onClick={this.handleMergeSubmit}>
                            Verknüpfen
                        </Button>
                    </DialogActions>
                </Dialog>

                <Snackbar open={this.state.changePasswordSnackbarOpen} autoHideDuration={5000} onClose={this.closeSnackbar}
                          anchorOrigin={{vertical: "top", horizontal: "right"}} TransitionComponent={Grow}>
                    <Alert onClose={this.closeSnackbar} severity={this.state.changePasswordSnackbarSeverity} sx={{width: '100%'}}>
                        {this.state.changePasswordSnackbarText}
                    </Alert>
                </Snackbar>
            </Box>
        );
    }
}

export default HeaderComponent;
